'use strict';

module.exports = {
  date: {
    titleFormat: 'dddd, MMMM D, YYYY',
    calendarMinThreshold: 10,
  },
  picker: {
    listMaxThreshold: 4,
  },
  // ex: 'Tue, Jul 23, 8:00 PM'
  ticketDateTimeFormat: 'ddd, MMM D, h:mm A,',

  // ex: 'Tue, Jul 23,'
  tbdTimeFormat: 'ddd, MMM D,',

  // ex: '8:00 PM,'
  tbdDateFormat: 'h:mm A,',
};
